export const Pagination = ({ page, pages, total, perPage, onPage, onPerPage, testId = "pagination" }) => (
  <div data-testid={testId} className="mt-4 flex flex-wrap items-center justify-between gap-3 text-xs text-[#94A3B8]">
    <div className="flex items-center gap-2">
      <span>Por página</span>
      <select
        data-testid={`${testId}-per-page`}
        value={perPage}
        onChange={(e) => onPerPage(Number(e.target.value))}
        className="h-9 rounded-md border border-[#22252F] bg-[#0F1116] px-2 text-xs text-white"
      >
        {[20, 30, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <span data-testid={`${testId}-total`}>{total} registo(s)</span>
    </div>
    <div className="flex items-center gap-2">
      <button
        data-testid={`${testId}-prev`}
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        className="rounded-md border border-[#22252F] px-3 py-2 transition-colors hover:text-white disabled:opacity-40"
      >
        Anterior
      </button>
      <span data-testid={`${testId}-label`} className="font-mono">Página {page} / {pages}</span>
      <button
        data-testid={`${testId}-next`}
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
        className="rounded-md border border-[#22252F] px-3 py-2 transition-colors hover:text-white disabled:opacity-40"
      >
        Seguinte
      </button>
    </div>
  </div>
);
